var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoisBountyCrownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_258_12549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5955 7.13541C16.8783 6.50508 15.7902 6.5916 15.1595 7.30844C14.5289 8.02528 14.6155 9.11291 15.3327 9.74324C15.1101 10.4477 13.9106 11.7702 12.4763 11.5971C10.8688 11.387 10.4483 9.18706 10.436 7.40731C10.9801 7.11069 11.3387 6.54216 11.3387 5.88711C11.3387 4.93544 10.572 4.1568 9.6075 4.1568C8.65537 4.1568 7.87636 4.92308 7.87636 5.88711C7.87636 6.54216 8.24732 7.11069 8.77903 7.40731C8.76666 9.1747 8.34624 11.3747 6.73875 11.5848C5.292 11.7702 4.10493 10.4354 3.88236 9.73088C4.59955 9.10055 4.67374 8.01292 4.05547 7.29608C3.42484 6.57924 2.33669 6.50508 1.6195 7.12305C0.914678 7.75338 0.840486 8.841 1.45875 9.55784C1.75552 9.90391 2.18831 10.114 2.65819 10.1511L4.29041 17.406H9.6075H14.9246L16.5568 10.1511C17.0143 10.1264 17.4471 9.91627 17.7563 9.55784C18.3869 8.841 18.3127 7.75338 17.5955 7.13541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4341 6.96952L4.43412 6.9695L4.43088 6.96582C3.61979 6.04385 2.21869 5.94675 1.29312 6.74427L1.29307 6.7442L1.28619 6.75035C0.379629 7.56109 0.282682 8.95923 1.07966 9.88387C1.38518 10.2399 1.7954 10.4803 2.24436 10.5897L3.80261 17.5158L3.8904 17.906H4.29041H9.6075H14.9246H15.3246L15.4124 17.5158L16.9695 10.5948C17.4154 10.4893 17.8234 10.2448 18.1333 9.88623C18.944 8.96269 18.8509 7.55882 17.9237 6.7582C16.9926 5.94163 15.5907 6.06136 14.7841 6.97818C14.0522 7.8102 14.0698 9.0193 14.7372 9.8428C14.6014 10.071 14.368 10.357 14.0506 10.6056C13.61 10.9506 13.0818 11.1657 12.5386 11.101C11.9975 11.0293 11.6009 10.6288 11.3245 9.91116C11.0769 9.26821 10.966 8.45823 10.9412 7.67614C11.49 7.26785 11.8387 6.61876 11.8387 5.88711C11.8387 4.6614 10.8502 3.6568 9.6075 3.6568C8.38179 3.6568 7.37636 4.64439 7.37636 5.88711C7.37636 6.62225 7.7366 7.26765 8.27383 7.67332C8.24911 8.45053 8.13822 9.25823 7.89058 9.90004C7.61393 10.617 7.21673 11.0178 6.67453 11.0889C6.12631 11.1589 5.59925 10.9444 5.1611 10.5989C4.845 10.3496 4.61246 10.0613 4.47701 9.83109C5.14548 9.0051 5.1479 7.79713 4.4341 6.96952Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_258_12549",
    x: 0.0390625,
    y: 3.1568,
    width: 19.646,
    height: 15.7493,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_12549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_12549",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoisBountyCrownIcon);
export default __webpack_public_path__ + "static/media/pois_bounty_crown_icon.46b7c3bb927adb603329c96f56ddde2d.svg";
export { ForwardRef as ReactComponent };